import { useQuery } from '@tanstack/react-query';
import { invalidateAll } from '../../api/queryClient';
import { trpc, type RouterOutputs } from '../../api/trpc';

export type Schedule = RouterOutputs['scheduler']['list'][number];

/** Every declared schedule with its next/last firing; refreshed every 30 s so "next run" stays honest. */
export function useSchedules() {
  return useQuery(trpc.scheduler.list.queryOptions(undefined, { refetchInterval: 30_000 }));
}

export function invalidateSchedules(): Promise<void> {
  return invalidateAll(trpc.scheduler.pathFilter());
}
